import * as THREE from 'three'
import Experience from '../Experience.js'
import  gsap  from "gsap"

export default class Stanza
{
    constructor(stanza)
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.sceneGroup = this.experience.sceneGroup
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug
        // this.world = this.experience.debug
        // Debug
        if(this.debug.active)
        {
            this.debugFolder = this.debug.ui.addFolder('stanza')
        }
        // Resource
        this.resource = this.resources.items[stanza]
        this.opacity={value:0}
        this.setModel()

    }
    setModel()
    {
        // conversione in basicmaterial
        const STDPattern= new RegExp('STD-')
        this.resource.scene.traverse((child) =>{
            if ( ! child.isMesh ) return;
            if (!STDPattern.test(child.name)){
                var prevMaterial = child.material;
                child.material = new THREE.MeshBasicMaterial();
                THREE.MeshBasicMaterial.prototype.copy.call( child.material, prevMaterial );
                child.material.transparent=true
            }
        })

        this.model = this.resource.scene
        this.myModel=[...this.model.children]
        this.AOPattern= new RegExp('AO-')
        const SHDPattern= new RegExp('SH-')
        const SHDPattern2= new RegExp('SH2-')
        const SHDPattern3= new RegExp('SH3-')
        const ORD8Pattern= new RegExp('OR8-')
        const MCPattern= new RegExp('MC-')
        const MCPattern2= new RegExp('MC2-')
        const MCPattern3= new RegExp('MC3-')
        let res=null

        const chromeMaterialMatcap=new THREE.MeshMatcapMaterial()
        chromeMaterialMatcap.matcap=this.resources.items.matcapTexture
        const cretaMaterialMatcap=new THREE.MeshMatcapMaterial()
        cretaMaterialMatcap.matcap=this.resources.items.matcapTexture2
        // const glassMaterialMatcap=new THREE.MeshMatcapMaterial()
        // glassMaterialMatcap.matcap=this.resources.items.matcapTexture3
        // glassMaterialMatcap.alphaMap=this.resources.items.matcapTexture3alpha
        // glassMaterialMatcap.transparent=true
        
        // this.environmentMap = {}
        // this.environmentMap.intensity = 0.8
        // this.environmentMap.texture = this.resources.items.envMap
        // console.log(this.environmentMap.texture)

        // const glassMaterial = new THREE.MeshStandardMaterial({
        //     metalness: 1,
        //     roughness: 0,
        //     envMapIntensity: 0.9,
        //     envMap:this.environmentMap,
        //     alphaMap:this.resources.items.trasparente,
        //     // clearcoat: 1,
        //     transparent: true,
        //     opacity: 0,
        //     // reflectivity: 0.2,
        //     // refractionRatio: 1,
        //     // ior: 0.9,
        //     // side: THREE.BackSide,
        //     })
        //     // glassMaterial.envMap=this.environmentMap
        // console.log(glassMaterial)
        this.AOmap={}
        this.AOuv={}
        const coloreOmbra=0x000000

        // const ombraDivano = new THREE.MeshBasicMaterial({
        //     color: coloreOmbra,transparent:true,depthWrite:false,
        //     map:this.resources.items.ombraDivano
        // })


        // const children = 
        // console.log(this.myModel)
        for (const child of this.myModel){
            res= child.name.split(this.AOPattern)
            if (res.length >1)
            // if (this.AOPattern.test(child.name))
            {
                this.AOuv[res[1]]=child.geometry.attributes.uv
                this.AOmap[res[1]]=child.material.map
                // child.disposeMesh
            }
        }
        // console.log(this.AOuv)
        for (const child of this.myModel){
            res= child.name.split(this.AOPattern)
            if (res.length ==1)
            {
                if (SHDPattern.test(child.name)){
                    child.renderOrder=4
                    child.material.opacity=this.opacity.value
                }
                if (SHDPattern2.test(child.name)){
                    child.renderOrder=3
                    child.material.opacity=this.opacity.value
                }
                if (SHDPattern3.test(child.name)){
                    child.renderOrder=2
                    child.material.opacity=this.opacity.value
                }
                if (ORD8Pattern.test(child.name)){
                    child.renderOrder=-1
                    child.material.transparent=true
                    child.material.opacity=this.opacity.value
                    child.material.format = THREE.RGBAFormat

                }
                else if (MCPattern.test(child.name)){
                    // child.renderOrder=2
                    child.material=chromeMaterialMatcap
                    child.material.opacity=this.opacity.value
                    child.material.transparent=true
                    // this.sceneGroup.add(child)
                    // console.log(child)

                }
                else if (MCPattern2.test(child.name)){
                    // child.renderOrder=2
                    child.material=cretaMaterialMatcap
                    child.material.opacity=this.opacity.value
                    child.material.transparent=true
                    // this.sceneGroup.add(child)
                    // console.log(child)

                }
                // else if (MCPattern3.test(child.name)){
                //     // child.renderOrder=2
                //     child.material.envMap=this.environmentMap
                //     child.material.needsUpdate=true


                //     // child.material=glassMaterialMatcap
                //     // child.material.opacity=this.opacity.value
                //     // child.material.transparent=true
                //     // this.sceneGroup.add(child)
                //      console.log(child.material)

                // }
                else if(child instanceof THREE.Mesh){
                    if (this.AOuv[res[0]]){
                        child.geometry.attributes.uv2=this.AOuv[res[0]]
                        child.material.aoMap=this.AOmap[res[0]]
                        child.material.aoMapIntensity=1
                        // child.receiveShadow = true
                        // child.material.map.minFilter = THREE.LinearFilter
                        child.material.map.minFilter = THREE.NearestMipmapLinearFilter
                        // child.material.map.minFilter = THREE.LinearMipmapLinearFilter

                        
                    }
                    // console.log(child)
                    // child.material.map.depthWrite = true
                    // child.material.map.depthTest = true
                    child.material.transparent = true
                    child.material.opacity=this.opacity.value
                    child.material.format = THREE.RGBAFormat
                    // child.position.y-=0.5
                    // console.log(child)
                    // this.sceneGroup.add(child)

               }else{
                   for (const secChild of child.children){
                    if(secChild instanceof THREE.Mesh){
                        secChild.geometry.attributes.uv2=this.AOuv[res[0]]
                        secChild.material.aoMap=this.AOmap[res[0]]
                        secChild.material.alphaTest = 0.001
                        // secChild.material.map.depthWrite = true
                        // secChild.material.map.depthTest = true
                        secChild.material.transparent = true
                        secChild.material.format = THREE.RGBAFormat
                        secChild.material.map.minFilter = THREE.NearestMipmapLinearFilter
                        // secChild.material.map.minFilter = THREE.LinearFilter

                    }
                    // console.log(secChild)
                   }

                // this.sceneGroup.add(child)
               }
            }
        }
        // this.ambLight= new THREE.AmbientLight('#ffffff',1.2)
        // this.sceneGroup.add(this.ambLight)

        // this.pointLight= new THREE.PointLight('#ffffff',5,5)
        // this.pointLight.position.set(0,1.5,-4)
        // // this.pointLight.position.set(0,1.5,-4)

        // this.sceneGroup.add(this.pointLight)
        // if(this.debug.active)
        // {
        //     this.debugFolder
        //         .add(this.pointLight.position, 'x')
        //         .name('pointlight x')
        //         .min(-20)
        //         .max(20)
        //         .step(0.01),
        //     this.debugFolder
        //         .add(this.pointLight.position, 'y')
        //         .name('pointlight y')
        //         .min(-20)
        //         .max(20)
        //         .step(0.01),
        //     this.debugFolder
        //         .add(this.pointLight.position, 'z')
        //         .name('pointlight z')
        //         .min(-20)
        //         .max(20)
        //         .step(0.01)
        // }




        // this.model.traverse((child) =>
        // {
        //     if (child.name === 'AO-Cube'){
        //         this.AOuv=child.geometry.attributes.uv
        //         this.AOmap=child.material.map
        //     }
        //     if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
        //     {
        //         // console.log(child.material)
        //         child.material.side = THREE.FrontSide
        //         child.material.transparent=true
        //         child.material.opacity=1
        //     }
        // })
        // this.model.traverse((child) =>
        // {
        //     if (child.name === 'Cube'){
        //         child.geometry.attributes.uv2=this.AOuv
        //         child.material.aoMap=this.AOmap
        //         this.scene.add(child)
        //     }
        // })

        // this.scene.add(this.model)
        // Debug
        if(this.debug.active)
        {
            this.debugFolder
                .add(this.opacity, 'value')
                .name('opacity')
                .min(0)
                .max(1)
                .step(0.001)
                .onChange(()=>{this.updateMat()})
        }
    }
    updateMat(){
        // this.myModel.traverse((child) =>
        for (const child of this.myModel)
        {
            // if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshBasicMaterial)
            if(child instanceof THREE.Mesh && child.material)
            {
                // console.log(child)
                child.material.opacity = this.opacity.value
                child.material.needsUpdate = true
            }
        }

    }
    hide(){
        // console.log(this.opacity)
        gsap.to(this.opacity,{value:0,duration:0.5,ease:'power1.inOut',onUpdate:()=>{this.updateMat()},onComplete:()=>{this.disposeMesh()}})
    }
    show(delay){
        setTimeout(()=>{
            for (const child of this.myModel){
                if(child instanceof THREE.Mesh && !this.AOPattern.test(child.name))
                {
                    // console.log(child)
                    this.sceneGroup.add(child)
                    // child.material.opacity = this.opacity.value
                    // child.material.needsUpdate = true
                }
                // console.log(child.name)
            }

        },delay)
        gsap.to(this.opacity,{value:1,duration:0.5,delay:1,ease:'power1.inOut',onUpdate:()=>{this.updateMat()}})
        
    }
    disposeMesh(){
        for (const child of this.myModel){
            this.sceneGroup.remove(child)
            // console.log(child.name)
        }
        // console.log('rimosso??')

    }


}